import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { toast } from "react-toastify";
import { useAppDispatch } from "src/hooks/redux";
import { openSocketNotification } from "src/redux/reducers/modals";
import { SESSION_KEYS, getDataFromSession } from "src/utils/session-storage";
import { reconnectSocket } from "src/workers/websocket.worker";
const CustomToastComp = () => {
    const dispatch = useAppDispatch();
    const reconnect = () => {
        reconnectSocket(getDataFromSession(SESSION_KEYS.CLIENT_CODE));
        //checkAndLogMessage("SOCKET_DATA_STREAM_STOPPED", { reason: "RESUBSCRIBED" });
        dispatch(openSocketNotification(false));
    };
    return (_jsxs("div", { children: [_jsx("p", { children: "Live Data Streaming Stopped" }), _jsx("button", Object.assign({ onClick: reconnect }, { children: "Reconnect" }))] }));
};
function SocketNotification() {
    const dispatch = useAppDispatch();
    // const showNotification = useAppSelector((state) => state?.modals?.socketNotification);
    // const [showsocketNotification,setShowsocketNotification] =useState(showNotification);
    // useEffect(() => {
    //   setShowsocketNotification(showNotification);
    // }, [showNotification]);
    const displayMsg = () => {
        toast.info(_jsx(CustomToastComp, {}), {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: false,
            onClose: () => dispatch(openSocketNotification(false)),
        });
        return _jsx(_Fragment, {});
    };
    return _jsx("div", { children: displayMsg() });
}
export default SocketNotification;
